import type { RouteListItem } from '@/types';

import ConferenceEvents from '../images/icons/megaphone.svg?react';

export const conferenceEventsSubNav: RouteListItem[] = [
  {
    path: '/conferences-and-events/$id',
    icon: ConferenceEvents,
    name: 'Conference & Events',
  },
];
